import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ServiceEvent, ServiceRequest } from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function createServiceRequest(payload: {
  id?: string;
  queue_id?: string | null;
  offering_id?: string | null;
  origin?: string;
  description?: string;
  preferred_timeframe?: string;
  mfg_unit_id?: string | null;
  opportunity_id?: string | null;
  contact_id?: string | null;
  location_label?: string;
  location_address?: string;
  quoted_amount_cents?: number | null;
  job_kind?: "internal" | "sold";
  ops_deal_id?: string | null;
  dispatch_now?: boolean;
}) {
  return manufacturingFetch<OrgEnvelope & { request: ServiceRequest; event_id?: string | null }>(
    "/api/service/requests/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function updateServiceEvent(payload: {
  event_id: string;
  scheduled_date?: string | null;
  scheduled_window_label?: string | null;
  tech_id?: string | null;
  assigned_rig_id?: string | null;
  status?: ServiceEvent["status"];
  title?: string;
  description?: string;
  location_label?: string;
  location_address?: string;
  customer_contacted?: boolean;
  customer_contacted_at?: string | null;
}) {
  return manufacturingFetch<OrgEnvelope & { event: ServiceEvent }>("/api/service/events/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function completeServiceEvent(payload: { event_id: string }) {
  return manufacturingFetch<OrgEnvelope & { event: ServiceEvent }>("/api/service/events/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event_id: payload.event_id, complete: true }),
  });
}

export function assignServiceEventDispatch(payload: {
  event_id: string;
  tech_id?: string | null;
  rig_id?: string | null;
  scheduled_date?: string | null;
}) {
  return manufacturingFetch<
    OrgEnvelope & { event: ServiceEvent; warnings?: string[] }
  >("/api/service/events/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
